import css from './ItemSelector.module.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import DataTestId from 'meta/dataTestId'
import { ISelectableGoodServiceTicket } from 'meta/pages/goodsandservices'
import { TICKETSMS_COLORS_LILA } from 'utils/constants/colors'

import Img from 'components/Media/Img'

interface Props {
  activeCardData: ISelectableGoodServiceTicket
  ticketsData: ISelectableGoodServiceTicket[]
  handleSelectedTicketData(data: ISelectableGoodServiceTicket, remove?: boolean): void
}

const ItemSelector: React.FC<Props> = (props) => {
  const { activeCardData, ticketsData, handleSelectedTicketData } = props

  const { t } = useTranslation()

  const [selectedCount, setSelectedCount] = useState(0)

  useEffect(() => {
    if (ticketsData.map((ticket) => ticket.idx).includes(activeCardData.idx)) {
      handleSelectedTicketData(ticketsData[0])
      setSelectedCount(1)
    }
  }, [])

  const addTicket = () => {
    if (selectedCount < ticketsData.length) {
      handleSelectedTicketData(ticketsData[selectedCount])
      setSelectedCount(selectedCount + 1)
    }
  }

  const removeTicket = () => {
    if (selectedCount > 0) {
      handleSelectedTicketData(ticketsData[selectedCount - 1], true)
      setSelectedCount(selectedCount - 1)
    }
  }

  return (
    <div className={css.wrapper} style={{ borderColor: ticketsData[0]?.data.customColor ?? TICKETSMS_COLORS_LILA }}>
      <div className={css.left}>
        <div className={css.title}>{ticketsData[0]?.data.notes}</div>
        <div className={css.count}>
          {String(t('goodsAndServices:multiple_available_no', { count: ticketsData.length }))}
        </div>
      </div>
      <div className={css.right}>
        <div data-testid={DataTestId.bag.btnMultipleSelectionMinus} className={css.minus} onClick={removeTicket}>
          <Img src={`/goodsandservices/multiple_minus_${selectedCount > 0 ? 'black' : 'grey'}.svg`} />
        </div>
        <div data-testid={DataTestId.bag.itemCount} className={css.selected}>
          {selectedCount}
        </div>
        <div data-testid={DataTestId.bag.btnMultipleSelectionPlus} className={css.plus} onClick={addTicket}>
          <Img src={`/goodsandservices/multiple_plus_${selectedCount < ticketsData.length ? 'black' : 'grey'}.svg`} />
        </div>
      </div>
    </div>
  )
}

export default ItemSelector
